import axios from 'axios';
import toast from '$$vueCmp/toast';
import app from '$$app';

const internalApi = axios.create({
  baseURL: '/api/internal',
});

const api = axios.create({
  baseURL: '/api',
});

const socketInterceptor = req => {
  const methods = ['post', 'put', 'delete'];

  if (methods.includes(req.method)) {
    req.headers.socketId = app.socket?.id || '';
  }

  return req;
};

const metaInterceptor = req => {
  req.meta = req.meta || {};
  req.meta.requestStartedAt = new Date().getTime();

  if (req.data) {
    req.meta.data = req.data;
  }

  return req;
};

api.interceptors.request.use(metaInterceptor);
internalApi.interceptors.request.use(metaInterceptor);

api.interceptors.request.use(socketInterceptor);
internalApi.interceptors.request.use(socketInterceptor);

internalApi.interceptors.response.use(response => response,
  error => {
    // const errorData = error.response.data;
    // errorData.code = 1
    // errorData.msg = common

    // const errorData = error.response.data[0];
    // errorData.code = 3005
    // errorData.msg = specific

    // console.log(error.response.config.meta);
    // console.log(error.response.config.method);
    // console.log(error.response.config.headers);

    if (error.config.url.includes('/ganttview')) {
      const options = error.response?.status === 502 || error.message === 'Network Error' || error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' ? { timeout: false } : {};

      toast.error(__('error_tasks_api_operation'), options);
    }
    if (error.config.url.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/comments')) {
      toast.error(__('error_tasks_api_operation'));
    }

    if (error.config.url.includes('/attachment')) {
      if (error.response?.data.code === 4005) {
        toast.error(__('fileUpload_limitStore', { limit: '' }));
      } else {
        toast.error(__('error_tasks_api_operation'));
      }
    }

    throw new Error(JSON.stringify({
      url: error.config.url,
      message: error.message,
      data: error.config.data && JSON.parse(error.config.data),
      userId: user?.id,
      teamId: user?.team?.id,
    }));
  });

api.interceptors.response.use(response => response,
  error => {
    // const errorData = error.response.data;
    // errorData.message
    // errorData.details.user
    // errorData.details.request

    // console.log(error.response.config.meta);
    // console.log(error.response.config.method);
    // console.log(error.response.config.headers);

    if (error.config.url.includes('/task')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/link')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (error.config.url.includes('/history')) {
      toast.error(__('error_tasks_api_operation'));
    }

    throw new Error(JSON.stringify({
      url: error.config.url,
      message: error.message,
      data: error.config.data && JSON.parse(error.config.data),
      userId: user?.id,
      teamId: user?.team?.id,
    }));
  });

// old webix support

const debouncedToastCall = _.debounce(locale => {
  toast.error(locale ? __(locale) : __('error_tasks_api_operation'));
}, 300);

webix.attachEvent('onBeforeAjax', (mode, url, data, request, headers, files, promise) => {
  // add code
  headers.socketId = app.socket.id || '';
  promise.then(data => {
    // try {
    //   data.json();
    // } catch (e) {
    //   debauncedToastCall();
    // }
  }, error => {
    debouncedToastCall();
  });
});

export {
  internalApi,
  api,
};
